import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs/Observable";
import {BookableService} from "../model/bookableService";
import {map, tap} from "rxjs/operators";
import {of} from "rxjs";
import {ServiceCategory} from "../model/serviceCategory";

@Injectable({
  providedIn: 'root'
})
export class BookableServiceService {

  constructor(private httpClient: HttpClient) { }

    /**
     * Gets all bookable services mapped by their category name either from the session storage if present or else from the api
     *
     * @return Observable containing a map with all service category names as key and an array of all corresponding bookable services as value
     */
    public getBookableServicesByCategoryFromStorageOrApi(options:{} = {}): Observable<Map<string, BookableService[]>> {
        let bookableServicesByCategory: Map<string, BookableService[]> = JSON.parse(sessionStorage.getItem("bookableServices"));

        if (bookableServicesByCategory) {
            return of(bookableServicesByCategory);
        } else {
            return this.getBookableServicesByCategory(options).pipe(
                    tap((res) => {
                        bookableServicesByCategory = res;
                        sessionStorage.setItem("bookableServices", JSON.stringify(bookableServicesByCategory));
                    }),
                    map(() => bookableServicesByCategory)
            )
        }
    }

    /**
     * Gets all service categories either from the session storage if present or else from the api
     *
     * @return Observable containing an array of all service categories
     */
    public getServiceCategoriesFromStorageOrApi(options:{} = {}): Observable<ServiceCategory[]>{
      let serviceCategories: ServiceCategory[] = JSON.parse(sessionStorage.getItem("serviceCategories"));

      if(serviceCategories){
          return of(serviceCategories)
      }
      else {
          return this.getServiceCategories(options).pipe(
                  tap((res) => {
                      serviceCategories = res;
                      sessionStorage.setItem("serviceCategories", JSON.stringify(serviceCategories));
                  }),
                  map(() => serviceCategories)
          )
      }
    }

    /**
     * Gets all bookable services mapped by their category name from the api
     *
     * @return Observable containing a map with all service category names as key and an array of all corresponding bookable services as value
     */
    public getBookableServicesByCategory(options:{} = {}): Observable<Map<string, BookableService[]>>{
        options['withCredentials'] = true;
        return this.httpClient.get<Map<string, BookableService[]>>("/api/bookable-services-by-categories", options);
    }

    /**
     * Gets all service categories from the api
     *
     * @return Observable containing an array of all service categories
     */
    public getServiceCategories(options:{} = {}): Observable<ServiceCategory[]>{
        options['withCredentials'] = true;
        return this.httpClient.get<ServiceCategory[]>("/api/bookable-services/categories", options);
    }
}
